export const getAllCategoriesList = () => {
  return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/category/get/all`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  })
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at getting  Categories list ${e}`));
};


export const CreateCaregory = body => {
  return fetch(`${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/category/create`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at Create  category ${e}`));
};

export const UpdateCategory = (body,id) => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/category/update/${id}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at update  category ${e}`));
};

export const deleteCategory = id => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/category/delete/${id}`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at deleting  category ${e}`));
};
